/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create and update a rule.
 * 
 * ``extra_params`` is validated against the action's declared spec, which is where reference
 * params are checked for resolving inside their scope — the same rule the admin's
 * ActionParamsField enforces.
 * 
 * ``position`` is read-only: the server owns it. New rules are appended, and order is changed
 * through the reorder endpoint, which is what keeps the per-action uniqueness constraint
 * satisfiable.
 * @export
 * @interface ActionRuleWriteRequest
 */
export interface ActionRuleWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof ActionRuleWriteRequest
     */
    transitionAction: string;
    /**
     * Leave empty for a rule that always matches.
     * @type {string}
     * @memberof ActionRuleWriteRequest
     */
    condition?: string | null;
    /**
     * Parameters passed to the action when this rule matches.
     * @type {any}
     * @memberof ActionRuleWriteRequest
     */
    extraParams?: any | null;
}

/**
 * Check if a given object implements the ActionRuleWriteRequest interface.
 */
export function instanceOfActionRuleWriteRequest(value: object): value is ActionRuleWriteRequest {
    if ((!('transitionAction' in (value as Record<string, any>)) && !('transition_action' in (value as Record<string, any>))) || ((value as Record<string, any>)['transitionAction'] === undefined && (value as Record<string, any>)['transition_action'] === undefined)) return false;
    return true;
}

export function ActionRuleWriteRequestFromJSON(json: any): ActionRuleWriteRequest {
    return ActionRuleWriteRequestFromJSONTyped(json, false);
}

export function ActionRuleWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionRuleWriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transitionAction': json['transition_action'],
        'condition': json['condition'] === undefined ? undefined : json['condition'] === null ? null : json['condition'],
        'extraParams': json['extra_params'] === undefined ? undefined : json['extra_params'] === null ? null : json['extra_params'],
    };
}

export function ActionRuleWriteRequestToJSON(json: any): ActionRuleWriteRequest {
    return ActionRuleWriteRequestToJSONTyped(json, false);
}

export function ActionRuleWriteRequestToJSONTyped(value?: ActionRuleWriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transition_action': value['transitionAction'],
        'condition': value['condition'],
        'extra_params': value['extraParams'],
    };
}

